<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="720px"
    append-to-body
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="formRef"
      label-width="120px"
      size="small"
    >
      <el-row :gutter="12">
        <el-col :span="12">
          <el-form-item label="模型类型" prop="modelType">
            <el-select v-model="form.modelType" placeholder="请选择">
              <el-option label="DeepSeek" value="deepseek" />
              <el-option label="Gemini" value="gemini" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="模型名称" prop="modelName">
            <el-input v-model="form.modelName" maxlength="50" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :span="12">
          <el-form-item label="API Key" prop="apiKey">
            <el-input v-model="form.apiKey" type="password" show-password />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="API 地址" prop="apiUrl">
            <el-input
              v-model="form.apiUrl"
              placeholder="https://api.example.com/v1"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :span="12">
          <el-form-item label="最大 Tokens" prop="maxTokens">
            <el-input-number
              v-model="form.maxTokens"
              :min="1"
              :max="100000"
              :step="100"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="温度 (0-1)" prop="temperature">
            <el-input-number
              v-model="form.temperature"
              :min="0"
              :max="1"
              :step="0.1"
              :precision="2"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :span="12">
          <el-form-item label="延迟秒数" prop="delaySeconds">
            <el-input-number v-model="form.delaySeconds" :min="0" :max="600" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="当前启用" prop="isActive">
            <el-switch v-model="form.isActive" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :span="12">
          <el-form-item label="智能回复开关" prop="enableSmartReply">
            <el-switch
              v-model="smartReplySwitch"
              @change="onSmartReplySwitch"
              active-text="启用"
              inactive-text="禁用"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取消</el-button>
      <el-button
        type="primary"
        :loading="isWorking"
        @click="confirm"
        size="small"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera.vue'
import {
  create as apiCreate,
  updateById as apiUpdate
} from '@/api/system/aiConfig'

export default {
  name: 'OperaAiConfigWindow',
  extends: BaseOpera,
  data () {
    return {
      form: {
        id: undefined,
        modelType: undefined,
        modelName: undefined,
        apiKey: undefined,
        apiUrl: undefined,
        maxTokens: 2000,
        temperature: 0.7,
        delaySeconds: 0,
        isActive: false,
        enableSmartReply: 0
      },
      rules: {
        modelType: [
          { required: true, message: '请选择模型类型', trigger: 'change' }
        ],
        modelName: [
          { required: true, message: '请输入模型名称', trigger: 'blur' }
        ],
        apiKey: [
          { required: true, message: '请输入 API Key', trigger: 'blur' }
        ],
        apiUrl: [
          { required: true, message: '请输入 API 地址', trigger: 'blur' }
        ],
        maxTokens: [
          { required: true, message: '请输入最大 Tokens', trigger: 'change' }
        ],
        temperature: [
          { required: true, message: '请输入温度', trigger: 'change' }
        ],
        delaySeconds: [
          { required: true, message: '请输入延迟秒数', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    smartReplySwitch: {
      get () {
        return Number(this.form.enableSmartReply) === 1
      },
      set (val) {
        this.form.enableSmartReply = val ? 1 : 0
      }
    }
  },
  methods: {
    onSmartReplySwitch (val) {
      this.form.enableSmartReply = val ? 1 : 0
    },
    open (title, target) {
      this.title = title
      this.visible = true
      this.$nextTick(() => {
        if (target) {
          this.form = { ...this.form, ...target }
        } else {
          this.form = {
            id: undefined,
            modelType: undefined,
            modelName: undefined,
            apiKey: undefined,
            apiUrl: undefined,
            maxTokens: 2000,
            temperature: 0.7,
            delaySeconds: 0,
            isActive: false,
            enableSmartReply: 0
          }
        }
        if (this.$refs.formRef) this.$refs.formRef.clearValidate()
      })
    },
    confirm () {
      if (this.isWorking) return
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.isWorking = true
        try {
          const payload = { ...this.form }
          if (payload.id) {
            await apiUpdate(payload)
          } else {
            await apiCreate(payload)
          }
          this.$message.success('保存成功')
          this.$emit('success')
          this.close()
        } catch (e) {
          this.$message.error(e && e.message ? e.message : '保存失败')
        } finally {
          this.isWorking = false
        }
      })
    },
    close () {
      this.visible = false
    }
  }
}
</script>
